import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

import { ErrorStrings } from 'src/app/constants/form.constants';
import { User } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user/user.service';
import { ActivatedRoute } from '@angular/router';
import { Alert } from 'src/app/interfaces/alert';
import { HttpErrorResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-update-email',
  templateUrl: './update-email.component.html',
  styleUrls: ['./update-email.component.scss'],
})
export class UpdateEmailComponent implements OnInit {
  errorStrings = ErrorStrings;
  loading = false;
  alert: Alert = null;
  model: any = {
    emailAddress: '',
    password: '',
  };
  user: User;
  isBrowser: boolean;
  useRebrandedLayout: boolean;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private featureFlagService: FeatureFlagsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.user = this.route.snapshot.data.user as User;
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  // TODO: When we have more time, we'll need to move the error handling inside the service
  save(form: NgForm) {
    this.closeAlert();
    this.loading = true;
    this.userService.updateEmail(this.model)
      .subscribe(
        () => {
          this.user.contact.email = this.model.emailAddress;
          form.controls.emailNew.reset();
          form.controls.emailNewConfirm.reset();
          this.alert = {
            type: 'success',
            message: 'Your email address has been updated.'
          };
          this.trackEvent('emailchange::updated');
        },
        err => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            this.alert = {
              type: 'danger',
              message: 'The current password entered is incorrect or the new email address is already taken.'
            };
          } else {
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.'
            };
          }
        }
      )
      .add(() => {
        this.loading = false;
        form.controls.passwordCurrent.reset();
      });
  }

  closeAlert() {
    this.alert = null;
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  ngOnInit(): void {
  }
}
